
/* eslint-disable react-hooks/exhaustive-deps */
import {
    createContext,
    useContext,
    useEffect,
    useState,
} from 'react';

import useTranslator from '../commons/translations';
import useWidgetTheme from '../commons/widgetTheme';
import { useAppStore } from './models/app';
import { useAppClientStore } from './models/appclient';

export const CommonStoresContext = createContext();

/* 
 * Global store contains singleton accessible states for all the renderable views,
 * It ensures that what is accessed by the others view is exactly the same copy of object.
 * Reducing memory used by the app
 */

export function useCommonStoreStates (p) {
    // * extends this to share all the properties as singleton , like translator

    const  {
        translate,
        translateWithValues,
    } = useTranslator();

    const appStore = useAppStore();
    const appClient = useAppClientStore();
    const [optins, setOptins] = useState([]);
    const [location, setLocation] = useState({});

    useEffect(() => {
        appClient.initWeblog();
    }, []);
    
    useEffect(() => {
        setOptins(appStore.optins);
        setLocation(appStore.location);
    }, [appStore.observed.optins]);
    
    const {
        widget,
        widgetTheme,
    } = useWidgetTheme();

    return {
        appStore,
        translate,
        translateWithValues,
        widget,
        widgetTheme,
        optins,
        location,
    };
}

function useCommonStores () {
    const globalStores = useContext(CommonStoresContext);
    return globalStores;
}

export default useCommonStores;